/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'ip-or-group-list';
const prefix = `${moduleName}.${componentName}`;

export const addItemBtnLabel = `${prefix}.addItemBtnLabel`;
export const orDataLabel = `${prefix}.orDataLabel`;

export const ENGLISH = {
    [addItemBtnLabel]: '+ Add Item',
    [orDataLabel]: 'or',
};
